import FormattedMessage from 'I18n/components/FormattedMessage';
import { Image } from 'foundations-components/transitional/components/Image';
// @ts-expect-error svg import
import agentHubLogo from 'bender-url!pricing-pages-ui-components/js/hsocImages/agent_hub_logo.svg';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import styled from 'foundations-theming/utils';
import { breakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FeatureListRoot = styled.div.withConfig({
  displayName: "PublicAeoFeatureList__FeatureListRoot"
})(({
  theme
}) => ({
  flex: 1,
  overflow: 'hidden',
  position: 'relative',
  backgroundColor: 'var(--fill-primary-hover)',
  padding: theme.space['800'],
  zIndex: 1,
  [breakpoint.tablet]: {
    padding: theme.space['500']
  }
}));
const FeatureItem = ({
  children
}) => /*#__PURE__*/_jsxs(Flex, {
  paddingInlineStart: "100",
  as: "li",
  alignItems: "center",
  gap: "200",
  children: [/*#__PURE__*/_jsx(SuccessIcon, {
    color: "fill-accent-orange-subtle"
  }), /*#__PURE__*/_jsx(Text, {
    marginBlock: "0",
    paddingBlock: "0",
    color: "text-primary-default",
    "data-style": "text-white",
    children: children
  })]
});
export const PublicAeoFeatureList = () => /*#__PURE__*/_jsxs(FeatureListRoot, {
  "data-style": "bg-teal-12",
  children: [/*#__PURE__*/_jsx(View, {
    "data-style": "bg-teal-13",
    backgroundColor: "fill-primary-hover",
    borderRadius: "full",
    position: "absolute",
    insetInlineEnd: "-5%",
    insetBlockStart: "-1%",
    inlineSize: "300%",
    blockSize: "200%",
    zIndex: 0
  }), /*#__PURE__*/_jsxs(View, {
    position: "relative",
    zIndex: 1,
    children: [/*#__PURE__*/_jsx(Text, {
      marginBlockEnd: "500",
      color: "text-primary-default",
      "data-style": "text-white",
      typography: "detail-200",
      paddingInlineStart: "100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.aeoPromoCard.whatsIncluded"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "600",
      children: /*#__PURE__*/_jsxs(Flex, {
        as: "ul",
        flexDirection: "column",
        gap: "200",
        listStyleType: "none",
        margin: "0",
        padding: "0",
        children: [/*#__PURE__*/_jsx(FeatureItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "publicPricingPage.aeoPromoCard.featureAiVisibility"
          })
        }), /*#__PURE__*/_jsx(FeatureItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "publicPricingPage.aeoPromoCard.featurePromptTracking"
          })
        }), /*#__PURE__*/_jsx(FeatureItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "publicPricingPage.aeoPromoCard.featureCompetitorComparison"
          })
        }), /*#__PURE__*/_jsx(FeatureItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "publicPricingPage.aeoPromoCard.featureCitationAnalysis"
          })
        }), /*#__PURE__*/_jsx(FeatureItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "publicPricingPage.aeoPromoCard.featureActionableRecommendations"
          })
        })]
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsxs(Flex, {
        "data-style": "bg-teal-11",
        backgroundColor: "fill-primary-hover",
        borderRadius: "full",
        alignItems: "center",
        gap: "200",
        paddingBlock: "100",
        paddingInline: "400",
        inlineSize: "fit-content",
        children: [/*#__PURE__*/_jsx(Text, {
          marginBlockEnd: "100",
          color: "text-primary-default",
          "data-style": "text-white",
          paddingBlockStart: "100",
          typography: "heading-500",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "publicPricingPage.aeoPromoCard.statMultiplier"
          })
        }), /*#__PURE__*/_jsx(Text, {
          color: "text-primary-default",
          "data-style": "text-white",
          typography: "detail-200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "publicPricingPage.aeoPromoCard.statDescription"
          })
        })]
      })
    }), /*#__PURE__*/_jsx(Text, {
      color: "fill-accent-light-orange-subtle",
      "data-style": "text-orange-05",
      paddingInlineStart: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.aeoPromoCard.includedInNote"
      })
    })]
  }), /*#__PURE__*/_jsx(View, {
    position: "absolute",
    insetInlineEnd: "15%",
    insetBlockStart: "16%",
    zIndex: 2,
    children: /*#__PURE__*/_jsx(Image, {
      src: agentHubLogo,
      alt: "",
      inlineSize: "55px",
      blockSize: "68px"
    })
  })]
});